<div class="settlement-agreement-table">
  <app-table
    [tableData]="tableData"
    tableName="table">
  </app-table>

  <ng-template #tableCopyBlueFapiaoTemplate
    let-blueFapiaoNumber="blueFapiaoNumber">
    @if (blueFapiaoNumber != null) {
      <div class="table-copy-wrapper">
        <app-tooltip [dynamic]="false" message="{{TOOLTIP_BLUE_FAPIAO_COPY}}">
          <button (click)="copySettlementTableClick(SettlementAgreementColumnEnum.BLUE_FAPIAO_NUMBER, blueFapiaoNumber)"
            class="table-copy-icon">
            <span class="iwp-icon-gen_copy" data-cy=table-copy-icon-blue-fapiao></span>
          </button>
        </app-tooltip>
      </div>
      <div class="table-copy-wrapper-number">
        <app-tooltip [dynamic]="false" message="{{blueFapiaoNumber}}">
          <span class="table-copy-value"
          data-cy="table-line-data-BLUE_FAPIAO_NUMBER">{{blueFapiaoNumber}}</span>
        </app-tooltip>
      </div>
    } @else {
      <div class="table-copy-undefined-value" data-cy="table-copy-undefined-value">{{UNDEFINED_PIPE}}</div>
    }
  </ng-template>

  <ng-template #tableCopyDeliveryNumberTemplate
    let-deliveryNumber="deliveryNumber">
    @if (deliveryNumber != null) {
      <div class="table-copy-wrapper">
        <app-tooltip [dynamic]="false" message="{{TOOLTIP_DELIVERY_NOTE_COPY}}">
          <button (click)="copySettlementTableClick(SettlementAgreementColumnEnum.DELIVERY_NUMBER, deliveryNumber)"
            class="table-copy-icon">
            <div class="iwp-icon-gen_copy" data-cy=table-copy-icon-delivery-number></div>
          </button>
        </app-tooltip>
      </div>
      <div class="table-copy-wrapper-number">
        <app-tooltip [dynamic]="false" message="{{deliveryNumber}}">
          <span class="table-copy-value" data-cy="table-line-data-DELIVERY_NUMBER">{{deliveryNumber}}</span>
        </app-tooltip>
      </div>
    } @else {
      <div class="table-copy-undefined-value" data-cy="table-copy-undefined-value">{{UNDEFINED_PIPE}}</div>
    }
  </ng-template>

  <ng-template #undefinedValue>
    <div class="table-copy-undefined-value" data-cy="table-copy-undefined-value">{{UNDEFINED_PIPE}}</div>
  </ng-template>

  <ng-template #commentTableTemplate let-commentIsNull="commentIsNull" let-commentTooltip="commentTooltip"
    let-commentValue="commentValue">
    <div class="settlement-agreement-comment-wrapper" data-cy="settlement-agreement-comment-wrapper">
      <app-tooltip [dynamic]="false" message="{{commentTooltip}}">
        <app-flying-menu [isDisable]="commentIsNull">
          <div class="settlement-agreement-comment-icon" labelFlyingMenu>
            <span class="iwp-icon-gen_comment"></span>
          </div>
          <div class="settlement-agreement-comment-content-wrapper" contentFlyingMenu>
            <div class="settlement-agreement-comment-label"
            data-cy="settlement-agreement-comment-label">{{LABEL_COMMENT_FLYING_MENU}}</div>
            <div class="settlement-agreement-comment-content"
            data-cy="settlement-agreement-comment-content">{{commentValue}}</div>
          </div>
        </app-flying-menu>
      </app-tooltip>
    </div>
  </ng-template>
</div>
